import requests from '../../api/client'
import { normalizeHttpFailure } from '../../api/normalizeApiError'
import { CartaoPagarResponse, HttpAnswer, HttpResult } from '../../types/otp'

export interface CartaoBruto {
  titular: string
  numero: string
  data_expiracao: string
  codigo_verificacao: string
}

export interface ThreeDS {
  Cavv: string
  Xid: string | null
  Eci: string
  Version: string
  ReferenceId: string | null
}

export interface PaymentCardParams {
  hash_unico: string
  cartao: CartaoBruto
  '3DS': ThreeDS
  creditCardToken?: string
}

export default async function paymentCard(
  params: PaymentCardParams
): Promise<HttpResult<CartaoPagarResponse>> {
  const response = (await requests.paymentCard(params)) as HttpAnswer & { headers?: unknown }
  const status = response?.status ?? 200
  const body = (response?.data ?? response) as CartaoPagarResponse

  // Fora do 2xx o corpo é o envelope de erro do middleware — que não tem
  // `mensagem`. Era daqui que vinha o motivo vazio no fluxo de pagamento.
  if (status < 200 || status >= 300) {
    return { status, body, error: normalizeHttpFailure(status, response?.data, response?.headers) }
  }

  return { status, body }
}